import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useRootSelector } from '@/hooks/selector.hook';

export default function Breadcrumb() {
    const breadcrumbItems = useRootSelector((state) => state.breadcrumb.items);

    if (breadcrumbItems.length === 0) {
        return null;
    }

    return (
        <nav className="hidden lg:flex items-center gap-[0.8rem] text-[1.4rem]" aria-label="Breadcrumb">
            {breadcrumbItems.map((item, index) => {
                const isLast = index === breadcrumbItems.length - 1;
                const isSecondToLast = index === breadcrumbItems.length - 2;

                return (
                    <div key={index} className="flex items-center gap-[0.8rem]">
                        {item.link && !isLast ? (
                            <Link
                                to={item.link}
                                className="dark:text-[#929292] text-[#BBBBBB] text-[2rem] font-medium hover:text-interactive transition-colors duration-200"
                            >
                                {item.title}
                            </Link>
                        ) : (
                            <span
                                className={`font-medium text-[2rem] ${isLast ? 'dark:text-[#CDCDCD] text-[#121212]' : 'text-[#BBBBBB]'}`}
                            >
                                {item.title}
                            </span>
                        )}
                        {!isLast && (
                            <ChevronRight
                                className={`w-[1.6rem] h-[1.6rem] ${isSecondToLast ? 'text-interactive' : 'sub-text'}`}
                            />
                        )}
                    </div>
                );
            })}
        </nav>
    );
}
